export function bufferLink() {
    const bufferLink = $(".buffer-link");

    bufferLink.on("click", function (e){
        e.preventDefault();
        const destination = $(this).attr('href');
        navigator.clipboard.writeText(destination);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/bufferLink.js